module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image1_bg-bcbae0509167184a21b9500d536add0d.png";